// @flow

import React from 'react';
import ErrorNotification from 'client/components/error/errorNotification';

type Props = {
  translateKey?: string,
  translateUsing?: Object,
  className?: string,
  theme: 'green' | 'orange' | 'red',
};

const FormErrorNotification = ({ className, theme, translateKey, translateUsing }: Props) => {
  if (!translateKey) return null;

  return (
    <ErrorNotification
      headerTranslationKey={`${translateKey}.header`}
      bodyTranslationKey={`${translateKey}.body`}
      using={translateUsing}
      theme={theme}
      border
      borderPosition="bottom"
      className={className} />
  );
};

FormErrorNotification.defaultProps = {
  translateKey: 'ede.notifications.error.form',
  translateUsing: {},
  className: '',
  theme: 'red',
};

export default FormErrorNotification;
